import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials, setCredentials } from "../../authSlice";

function ExportReports() {
  const { token } = useSelector((state) => state.auth);
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // const handleDateChange = (event) => {
  //   setSelectedDate(event.target.value);
  // };
  const handleDateChange = (e) => {
    const value = e.target.value;

    // Allow only digits and dashes, max length 10 (DD-MM-YYYY)
    if (/^[0-9-]*$/.test(value) && value.length <= 10) {
      setSelectedDate(value);
    }
  };

  const exportReport = async () => {
    if (!selectedDate) return;
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/sales/getSalespdf?date=${selectedDate}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 401) {
        dispatch(clearCredentials());
        return
      }

      if (response.ok) {
        const newAccessToken = response.headers.get("Authorization");
        if (newAccessToken) {
          dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
        }
        const blob = await response.blob();
        // Create a download URL for the blob
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `Report-${selectedDate}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        throw new Error("Failed to fetch report.");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="whiteBgDiv dashboardTablePadding">
        <div className="mainHeading">Reports</div>
        <div className="formHeading UserManagementpage">
          Export Reports / Sale Parchi
        </div>
        <div className="d-flex align-items-end flex-wrap gap-3">
          <div
            className="formInputLabelBox"
            style={{ flex: "1", minWidth: "250px" }}
          >
            <label>Choose Date</label>
            <input
              name="chooseDate"
              placeholder="Choose Date"
              type="date"
              id="date"
              style={{ padding: "10.5px 21px" }}
              value={selectedDate}
              onChange={handleDateChange}
            />
          </div>
          {loading ? (
            <button className="grayBtn">Loading...</button>
          ) : (
            <button className="colorBtn" onClick={exportReport}>
              Export
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default ExportReports;
